<template>
  <div>
    <div class="mb-4 d-flex align-items-center justify-content-between" style="flex-wrap: wrap;">
      <div class="d-flex align-items-center justify-content-start" style="flex-wrap: wrap;">
        <h3 class="title my-1">Audience</h3>
      </div>
      <button
        @click="openAudienceModal('new')"
        class="ml-2 my-1 btn btn-sm btn-primary text-white my-0"
      >
        <ion-icon name="ios-add-circle" class="text-white"></ion-icon>
        <span>Add audience</span>
      </button>
    </div>

    <div class="card">
      <div class="card-body px-4 py-2">
        <div v-if="audience && audience.length">
          <div
            v-for="(single, index) in audience"
            :key="single._id"
            class="d-flex justify-content-start my-3"
          >
            <div class="mr-3">
              <div
                style="width: 48px; height: 48px;"
                class="d-flex align-items-center justify-content-center text-white rounded-circle text-uppercase"
                :class="[single.type.toLowerCase()==='sms'?'bg-dark':'bg-info']"
              >{{single.type}}</div>
            </div>
            <div class="d-flex justify-content-start flex-column w-100">
              <h6>{{ single.description }}</h6>
              <p>{{single.body}}</p>
              <p v-if="isUserAdmin">
                <button
                  @click="openAudienceModal('edit', single)"
                  class="d-inline-block mr-2 btn btn-sm btn-light my-0"
                >
                  <ion-icon name="ios-brush" class></ion-icon>
                  <span>Edit</span>
                </button>
                <button
                  @click="deleteAudience(single)"
                  class="d-inline-block mr-2 btn btn-sm btn-danger my-0"
                >
                  <ion-icon name="ios-trash" class></ion-icon>
                  <span>Delete</span>
                </button>
              </p>
              <!-- horizontal line -->
              <div v-if="index !== audience.length-1" class="mt-3 border-top"></div>
            </div>
          </div>
        </div>

        <div v-else>Found no audience</div>
      </div>
    </div>

    <div class="audience-modal">
      <div
        class="modal fade"
        id="audienceModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="audienceModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <div>
                <h5 class="title my-0">{{action==='new' ? 'New' : 'Edit'}} Audience</h5>
              </div>
            </div>
            <div class="modal-body pt-3">
              <div class="row">
                <div class="form-group col-12 pb-3">
                  <label>
                    <small class="text-muted">Audicence type</small>
                  </label>
                  <select
                    v-model="audienceForm.type"
                    name="new-audience-type"
                    id="new-audience-type"
                    class="form-control w-100"
                  >
                    <option value="email">
                      <b>Email</b>
                    </option>
                    <option value="sms">
                      <b>Phone</b>
                    </option>
                  </select>
                </div>
                <div class="form-group col-12 pb-3">
                  <label>
                    <small>Audience description</small>
                  </label>
                  <input
                    v-model="audienceForm.description"
                    id="new-audience-description"
                    type="text"
                    placeholder="Description"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-12 pb-3">
                  <label>
                    <small class="text-muted" v-if="audienceForm.type==='email'">Email list</small>
                    <small class="text-muted" v-else>Phone number list</small>
                    {{validAudienceBody.length ? `(${validAudienceBody.length} valid)` : null}}
                  </label>
                  <textarea v-model="audienceForm.body" class="form-control"></textarea>
                </div>
              </div>
              <div
                class="mt-3 d-flex align-items-center justify-content-end"
                style="flex-wrap: wrap"
              >
                <button
                  id="addMemberDismissBtn"
                  @click="resetAudienceForm()"
                  data-dismiss="modal"
                  class="btn btn-light mr-2 my-1 btn-sm"
                >Cancel</button>
                <button
                  @click="submit($event)"
                  :disabled="!formValid || submitting"
                  class="btn btn-primary my-1 btn-sm"
                >{{ action==='new' ? 'Create':'Update' }} Audience</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleService from "@/services/circle";
import ContentService from "@/services/content";
import * as countries from "@/constants/countries";
import swal from "sweetalert";

const circleService = new CircleService();
const contentService = new ContentService();

export default {
  name: "CircleMemberList",
  props: [
    "members",
    "circle_id",
    "isUserAdmin",
    "contentLoading",
    "user",
    "identities",
    "circleIdentities"
  ],
  data() {
    return {
      audience: [],
      audienceForm: {
        type: "phone",
        description: "",
        body: ""
      },
      action: "",
      submitting: false
    };
  },
  methods: {
    loadAudience() {
      contentService
        .readCircleAudience(this.$props.circle_id)
        .then(res => {
          this.audience = res.data;
        })
        .catch(err => {
          this.$root.$emit("ShowErrorNotification", err.message);
        });
    },
    resetAudienceForm() {
      this.audienceForm = {
        type: "sms",
        description: "",
        body: ""
      };
    },
    openAudienceModal(action, audience = null) {
      let _this = this;
      let hy = [];

      if (action === "new") {
        this.resetAudienceForm();
        this.action = "new";
        this.audienceForm = {
          ...this.audienceForm,
          circle_id: this.circle_id,
          profile_id: this.user._id
        };
        $("#audienceModal").modal("show");
        return;
      }

      try {
        _this.action = "edit";

        _this.audienceForm = {
          _id: audience._id,
          circle_id: audience.circle_id,
          profile_id: audience.profile_id,
          description: audience.description,
          body: audience.body,
          type: audience.type
        };
        $("#audienceModal").modal("show");
      } catch (e) {
        this.$root.$emit("ShowErrorNotification", e.message);
        console.log(e);
      }
    },
    submit(e) {
      if (this.action === "new") {
        this.submitting = true;
        contentService
          .createCircleAudience({
            ...this.audienceForm,
            body: this.validAudienceBody.join(",")
          })
          .then(res => {
            // console.log(res)
            this.submitting = false;
            this.audience.unshift({
              ...this.audienceForm,
              _id: res.data
            });
            this.$root.$emit('CreateAudience', {
              ...this.audienceForm,
              _id: res.data
            });
            $("#audienceModal").modal("hide");
          })
          .catch(err => {
            this.submitting = false;
            console.log(err);
          });
      } else {
        let _this = this;
        this.submitting = true;
        contentService
          .updateCircleAudience({
            ...this.audienceForm,
            body: this.validAudienceBody.join(",")
          })
          .then(res => {
            // console.log(res)
            _this.submitting = false;
            _this.audience = _this.audience.map(item => {
              if (item._id === _this.audienceForm._id) {
                item = Object.assign(item, _this.audienceForm, {
                  body: _this.validAudienceBody.join(",")
                });
                this.$root.$emit('UpdateAudience', item)
              }
              return item;
            });
            
            $("#audienceModal").modal("hide");
          })
          .catch(err => {
            this.submitting = false;
            console.log(err);
          });
      }
    },
    deleteAudience(audience) {
      swal({
        text: `Delete ${audience.description}?`,
        icon: "warning",
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
            contentService.deleteCircleAudience(audience._id)
                .then(res => {
                    this.audience = this.audience.filter(item => {
                        return item._id !== audience._id
                    })
                    this.$root.$emit('DeleteAudience', audience._id)
                    swal(
                        "",
                        "Audience was deleted successfully!",
                        "success"
                    );
                })
                .catch(err => {
                    this.$root.$emit('ShowErrorNotification', err.message)
                    console.log(err)
                })
        }
      });
    }
  },
  mounted() {
    this.loadAudience();
  },
  computed: {
    smsAudience: function() {
      return this.audience
        ? this.audience.filter(s => s.type.toLowerCase() === "sms")
        : [];
    },
    emailAudience: function() {
      return this.audience
        ? this.audience.filter(s => s.type.toLowerCase() === "email")
        : [];
    },
    validAudienceBody: function() {
      let body = null;
      if (this.audienceForm.type === "email") {
        let emails = this.audienceForm.body.split(",");
        body = emails.filter(item =>
          item.replace(" ", "").match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
        );
      } else {
        let phoneLines = this.audienceForm.body.replace(" ", "").split(",");
        body = phoneLines.filter(item =>
          item.match(/^\+(?:[0-9] ?){6,14}[0-9]$/)
        );
      }

      return body || null;
    },
    formValid: function() {
      return (
        this.validAudienceBody.length &&
        this.audienceForm.hasOwnProperty("description") &&
          this.audienceForm.description !== ""
      );
    }
  }
};
</script>

<style scoped lang="scss">
tr:not(:last-of-type) {
  border-bottom: 1px solid lightgray;
}

.btn-shell {
  background: none;
  border: none;
  height: auto;
  width: auto;
  margin: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
}

.form-group {
  margin: 0 !important;
}
</style>
<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>